import SearchParamsBase from '../../../Elements/SearchParamsBase';
import InputTypesEnum from '../../../Enums/InputTypesEnum';

export default class TpWaveSearchParams extends SearchParamsBase {
  static iconName = 'fa-solid fa-search';
  static saveType = 'TpWaveSearchParams';

  constructor() {
    super();
    this.TpWaveId = '';
    this.ThirdPartyWaveName = '';
    this.ThirdPartyWaveId = '';
    this.ThirdPartyClientId = '';
    this.ThirdPartySource = '';
  }
  initialize() {
    this.TpWaveId = '';
    this.ThirdPartyWaveName = '';
    this.ThirdPartyWaveId = '';
    this.ThirdPartyClientId = '';
    this.ThirdPartySource = '';
  }

  static fieldsInSearchBox = [
    { fieldName: 'TpWaveId', label: 'Third-Party Wave ID', className: 'col-3', type: InputTypesEnum.Number },
    { fieldName: 'ThirdPartyWaveName', label: 'Third-Party Wave Name', className: 'col-3' },
    { fieldName: 'ThirdPartyWaveId', label: 'Third-Party Wave ID', className: 'col-3' },
    { fieldName: 'ThirdPartyClientId', label: 'Third-Party Client ID', className: 'col-3' },
    {
      fieldName: 'ThirdPartySource',
      label: 'Third-Party Source',
      className: 'col-3',
      type: InputTypesEnum.ThirdPartySourceSelect,
    },
  ];
}
